import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import ProfileImg from "../../assets/img/profileImg.svg";
import EmployeImg from "../../assets/img/experianCheck.svg";
import notIcon from "../../assets/img/noticIcon.svg";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import bagImg from "../../assets/img/employeSVG.svg";
import Guarantors from "../../assets/img/Guarantors.svg";
import WhiteBackgroundGuarantor from "../../assets/img/WhiteBackgroundGuarantor.svg";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import ExchangeIcon from "../../assets/img/exchange-icon.svg";
import Cancelimg from "../../assets/img/cancel-01.svg";
import MissingIcon from "../../assets/img/zondicons.svg";
import crossIcon from "../../assets/img/cross-new.svg";
import useTranslator from "../../hooks/useTranslator";
import {
  amlKycChecks,
  getIdentityDetails,
  haveValue,
  isDefaulter,
  isKycAmlDefaultApproved,
  ONFIDO_TOOLTIP_PRIORITY,
} from "../../helper/common";
import constants from "../../Utils/constants";
import UserBack from "../../assets/img/arrow-left-02-round.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ApplicationsModal from "./ApplicationsModal";
import NewApplicationModal from "./NewApplicationModal";
import ApplicationContext from "../../context/application/ApplicationContext";
import { getInitials } from "../../helper/applicationHelpers";
import axiosInstance from "../../services/authWrapper";
import AuthContext from "../../context/auth/AuthContext";
import FullidAuthentication from "../Tenant/FullidAuthentication";
import { useMediaQuery } from "react-responsive";
import Summary from "../Summary";
import FreeTextModal from "../Tenant/FreeTextModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import KycAmlCheckReportModal from "./KycAmlCheckReportModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import TenantContext from "../../context/tenant/TenantContext";
import LandLordContext from "../../context/landlord/LandLordContext";
import { isSkorSdkSearch } from "../../helper/skorSdk";

const TenantDetailsHeader = (props) => {
  const { _t } = useTranslator();
  const isMobile = useMediaQuery({ maxWidth: 667 });
  const queryParameters = new URLSearchParams(window.location.search);
  const { workspaceId } = useParams();
  const guarantor_id = queryParameters.get("guarantor");
  let [isFirstTime, setIsFirstTime] = useState(
    queryParameters.get("welcome") ?? false
  );
  const [showModal, setShowModal] = useState(false);
  const [showApplicationsModal, setShowApplicationsModal] = useState(
    queryParameters.get("applications") === "true"
  );
  const [showNewApplicationModal, setShowNewApplicationModal] = useState(false);
  const [showKycPopup, setShowKycPopup] = useState(
    queryParameters.get("kyc") === "true"
  );
  const [showFreeTextPopup, setShowFreeTextPopup] = useState(false);
  const [isOpenSummary, setIsOpenSummary] = useState(false);
  const [showAmlKycChecks, setShowAmlKycChecks] = useState(false);

  const tenantContext = useContext(TenantContext);
  const { isSecWelcomePopup } = tenantContext;

  const landLordContext = useContext(LandLordContext);
  const { getProfileResolutionStatus } = landLordContext;
  const [kycResolution, setKycResolution] = useState(null);

  const [showAppWelcomePopup, setShowAppWelcomePopup] = useState(
    queryParameters.get("welcome") === "true" && isSecWelcomePopup
  );

  const { loadUser, user: originalUser } = useContext(AuthContext);
  const {
    myApplications,
    pendingApplications,
    applicationsLoading,
    loadApplicationsData,
    fetchLandlordTenantApplications,
  } = useContext(ApplicationContext);

  const [landlordTenantApps, setLandlordTenantApps] = useState([]);
  const [landlordTenantAppsLoading, setLandlordTenantAppsLoading] =
    useState(false);

  const {
    user = {},
    forensicAnalysis = null,
    userIncome = {},
    setShowDefaulterCheck,
    setInsurableModal,
    fullinfo,
    setUpdateSourceObj,
    handleUpdateSource,
    showReportIcons = true,
    setOpenGuarantorModel,
    isGuarantor,
    isFromReport,
    setShowChatBot,
    SetIsSentEmailDrawer,
    updateTenantData,
    loadFullInfo,
    llShowOnly,
  } = props;

  const loadKycResolutions = useCallback(async () => {
    if (!user?._id) return;
    if (!llShowOnly) return;
    try {
      const response = await getProfileResolutionStatus(user._id, "kyc");
      setKycResolution(response);
      return response;
    } catch (error) {
      console.log(error, "Error in getProfileResolutionStatus");
      setKycResolution(null);
    }
  }, [getProfileResolutionStatus, user?._id]);

  useEffect(() => {
    loadKycResolutions();
  }, [loadKycResolutions]);

  const isGuarantorUser = useMemo(() => user?.gurantor_for?.length > 0, [user]);

  const experianData =
    user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

  const [kycDetails, setKycDetails] = useState(null);
  useEffect(() => {
    setKycDetails(getIdentityDetails(user, user?.onfido_user_kyc));
  }, [user]);

  useEffect(() => {
    if (!llShowOnly || !user?._id || props.reportMode) return;
    setLandlordTenantAppsLoading(true);
    const sharedId = queryParameters.get("sharedprofileid");
    fetchLandlordTenantApplications(sharedId)
      .then((apps) => setLandlordTenantApps(apps))
      .catch(() => setLandlordTenantApps([]))
      .finally(() => setLandlordTenantAppsLoading(false));
  }, [user?._id, llShowOnly]);

  useEffect(() => {
    if (queryParameters.get("applications") === "true") {
      const url = new URL(window.location.href);
      url.searchParams.delete("applications");
      window.history.replaceState({}, "", url.toString());
    }

    if (queryParameters.get("welcome") === "true") {
      const url = new URL(window.location.href);
      url.searchParams.delete("welcome");
      window.history.replaceState({}, "", url.toString());
    }

    const handleOpenApplications = () => setShowApplicationsModal(true);
    window.addEventListener("openApplicationsModal", handleOpenApplications);
    return () =>
      window.removeEventListener(
        "openApplicationsModal",
        handleOpenApplications
      );
  }, []);

  useEffect(() => {
    if (isSecWelcomePopup) {
      setShowAppWelcomePopup(true);
    }
  }, [isSecWelcomePopup]);

  const getEmploymentStatus = () => {
    if (user?.employment_status == constants.employed) {
      return _t("employed");
    }
    if (user?.employment_status == constants.self_employed) {
      return _t("selfEmployed");
    }
    if (user?.employment_status == constants.student) {
      return _t("student");
    }
    if (user?.employment_status == constants.unemployed) {
      return _t("unemployed");
    }
    if (user?.employment_status == constants.retired) {
      return _t("retired");
    }
    if (user?.employment_status == constants.public_servant) {
      return _t("publicServant");
    }
    if (user?.employment_status == constants.company) {
      return _t("company");
    }

    return _t("na");
  };
  const navigate = useNavigate();
  const location = useLocation();

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  const handleChangeSource = () => {
    handleUpdateSource();
    setUpdateSourceObj([
      {
        _id: userIncome?.all_sources?._id,
        all_sources: userIncome?.all_sources,
        current_selected: userIncome?.source,
        current_income_mode: userIncome?.source_mode,
        type: "tenant",
      },
    ]);
  };

  const updateUserSharerData = async (data) => {
    try {
      if (!haveValue(data?.is_edit)) {
        data.is_edit = true;
      }
      await axiosInstance.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/profile/${user?._id}`,
        data,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      loadUser("tenant");
    } catch (error) {
      console.log("Error updating user");
    }
  };

  const getConsiderResult = (breakdown, path) => {
    const [section, field] = path.split(".");

    const sectionData = breakdown?.[section];
    if (!sectionData) return false;

    // Check nested breakdown field result
    const fieldResult = sectionData?.breakdown?.[field]?.result;
    if (fieldResult === "consider") return true;

    // Also catch properties-level "consider" (e.g. original_document_present.properties.*)
    const properties = sectionData?.breakdown?.[field]?.properties;
    if (properties) {
      return Object.values(properties).some((v) => v === "consider");
    }

    return false;
  };

  const getReviewReason = () => {
    const output =
      user?.onfido_user_kyc?.onfido_workflow_res?.resource?.output ??
      user?.onfido_user_kyc?.onfido_workflow_res?.output;
    const status =
      user?.onfido_user_kyc?.onfido_workflow_res?.resource?.status ??
      user?.onfido_user_kyc?.onfido_workflow_res?.status;

    if (status === "review" && output?.document_type === "unidentified") {
      return llShowOnly
        ? _t(
            "onfidoUnidentifiedDocumentReviewLandlordMessage",
            "The tenant uploaded unsupported identification documents, so identity verification could not be completed successfully. Please ask the tenant to upload a valid government-issued ID with a visible photo. Copies or scanned documents are not accepted."
          )
        : _t(
            "onfidoUnidentifiedDocumentReviewTenantMessage",
            "Please upload a photo of a valid identification document that clearly shows your face. Copies or scanned documents are not accepted."
          );
    }

    const breakdown = output?.document_report?.breakdown;

    if (!breakdown) return _t("onfidoFallbackMessage");

    const isSanctions =
      breakdown?.image_integrity?.breakdown?.supported_document?.properties
        ?.issuing_country_subject_to_sanctions;

    if (isSanctions) {
      return _t("onfidoImageIntegritySanctionsMessage");
    }

    for (const { path, message } of ONFIDO_TOOLTIP_PRIORITY) {
      if (getConsiderResult(breakdown, path)) {
        return _t(message);
      }
    }

    const hasAnyConsider = Object.values(breakdown).some(
      (section) =>
        section?.result === "consider" ||
        Object.values(section?.breakdown ?? {}).some(
          (field) => field?.result === "consider"
        )
    );

    return hasAnyConsider ? _t("onfidoFallbackMessage") : null;
  };

  const flaggedGuarantors =
    !llShowOnly &&
    Array.isArray(user?.tenant_extra_field_id?.selected_onboarding_users)
      ? user.tenant_extra_field_id.selected_onboarding_users?.filter(
          (item) => item?.type == "guarantor"
        )?.length
      : 0;

  const handleNavigateReport = () => {
    const sharedId =
      queryParameters.get("agencylink") ||
      queryParameters.get("sharedprofileid");
    let queryParam = haveValue(queryParameters.get("agencylink"))
      ? `agencylink=${sharedId}`
      : `sharedprofileid=${sharedId}`;
    if (haveValue(guarantor_id)) {
      queryParam += `&guarantor_id=${guarantor_id}`;
    }

    const redirectUrl = window.location.pathname + window.location.search;
    queryParam += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;

    window.open(
      `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/${
        haveValue(workspaceId) ? workspaceId + "/" : ""
      }generatedReport/${sharedId}?${queryParam}`,
      "_blank"
    );
  };

  const IncomeTooltip = () => (
    <>
      <img
        data-tooltip-id="tenant-details-header-tooltip"
        src={moreInfoimg}
        alt="Vector Icon"
        className="vactorImg vactorImg1"
      />
      <ReactTooltip
        id="tenant-details-header-tooltip"
        place="left"
        noArrow
        className="react-tooltip-styling"
        render={() => (
          <p>
            {haveValue(userIncome?.method)
              ? _t(userIncome?.method)
              : _t("noIncomeSelected")}
          </p>
        )}
      />
    </>
  );

  const isInsurable = originalUser?.current_workspace?.insurance_service_status;

  useEffect(() => {
    if (isOpenSummary) {
      document.body.classList.add("profile-open");
    } else {
      document.body.classList.remove("profile-open");
    }

    return () => document.body.classList.remove("profile-open");
  }, [isOpenSummary]);

  const { pathname } = useLocation();

  const hideContainer =
    pathname.includes("generatedReport") ||
    pathname.includes("report-overview") ||
    pathname.includes("capacity-report") ||
    pathname.includes("linked-report-overview");

  const handleGoBack = () => {
    if (isSkorSdkSearch()) {
      navigate(-1);
      return;
    }

    const currentFullPath = location.pathname + location.search + location.hash;
    const fallbackPath = `/${workspaceId}/profile-request`;
    const maxAttempts = 5; // Prevent infinite loops
    let attempts = 0;

    const tryNavigateBack = () => {
      const currentIdx = window.history.state?.idx || 0;

      if (currentIdx === 0 || attempts >= maxAttempts) {
        // No more history or too many attempts
        navigate(fallbackPath, { replace: true });
        return;
      }

      navigate(-1);
      attempts++;

      setTimeout(() => {
        const newFullPath =
          window.location.pathname +
          window.location.search +
          window.location.hash;

        if (newFullPath === currentFullPath) {
          // Still on same URL, try again
          tryNavigateBack();
        }
        // If URL changed, we're done (navigation succeeded)
      }, 50);
    };

    if (window.history.state?.idx > 0) {
      tryNavigateBack();
    } else {
      navigate(-1);
    }
  };

  const isProfileOutdated = !!(user?.profile_outdated || user?.is_outdated);

  const userType = localStorage.getItem("usertype");

  return (
    <>
      <div
        className={`${!hideContainer && "profileinfo"} ${
          !llShowOnly ? "profileTenant" : ""
        } ${isFromReport ? "profileinfoReport" : ""}
        ${isSkorSdkSearch() ? "isSkorSdkProfileMode" : ""}`}
        style={{
          ...(userType === "admin"
            ? {
                top: "1.5556vw",
              }
            : {}),
        }}
      >
        <div className="row">
          <div className="col">
            <div className="mobileNavbar hideOnDesktop">
              {llShowOnly && (
                <p
                  className="Profileheading_change1 hideOnDesktop"
                  onClick={() => navigate(-1)}
                >
                  <img src={UserBack} alt="Vector Icon" className="vactorImg" />
                </p>
              )}
              <div className="userfixed_css d-flex align-items-center justify-content-center">
                <div>
                  <p className="Profileheading_change">
                    {haveValue(forensicAnalysis?.Name?.dataInJSON?.name) ? (
                      (() => {
                        const name =
                          forensicAnalysis.Name.dataInJSON.name.trim();
                        const parts = name.split(/\s+/);
                        let prefix = "";

                        if (parts.length >= 2) {
                          prefix =
                            parts[0].charAt(0).toUpperCase() +
                            parts[1].charAt(0).toUpperCase();
                        } else {
                          prefix = parts[0].charAt(0).toUpperCase();
                        }

                        return prefix;
                      })()
                    ) : (
                      <>
                        {user?.fname && user.fname.charAt(0).toUpperCase()}
                        {user?.lname && user.lname.charAt(0).toUpperCase()}
                      </>
                    )}
                  </p>
                </div>
              </div>
              <div className="hideOnDesktop incomeMobile">
                <div className="incomeDiv">
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <div className="d-flex align-items-center gap-2">
                        <p className="Profileheading_change mb-2">
                          {_t(
                            "selectedAnnualIncome",
                            "On new Skor Lite tenantDetails page header"
                          )}
                        </p>
                        <img
                          data-tooltip-id="userincome-method-tooltip"
                          src={moreInfoimg}
                          alt="Vector Icon"
                          className="vactorImg vactorImg1"
                        />
                        <ReactTooltip
                          id="userincome-method-tooltip"
                          place="bottom"
                          noArrow
                          className="react-tooltip-styling"
                          render={() => <p> {userIncome?.method} </p>}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between gap-4">
                        <div className="d-flex align-items-center">
                          <p className="Profileheading_change3">
                            €{userIncome?.amount}
                          </p>
                          {showReportIcons &&
                            llShowOnly &&
                            haveValue(userIncome?.all_sources) && (
                              <div className="re-do-icon-wrapper header-icon-wrapper">
                                <img
                                  src={ExchangeIcon}
                                  alt=""
                                  onClick={handleChangeSource}
                                  style={{ cursor: "pointer" }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="documentNumberWrapper">
                <div className="d-flex gap-2">
                  <img src={bagImg} alt="Vector Icon" className="vactorImg" />
                  <div>
                    <p className="Profileheading_change mb-2">
                      {_t("employmentStatus")}
                    </p>
                    <p className="Profileheading_change2">
                      {getEmploymentStatus()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`profileheading ${
                !llShowOnly ? "profileHeadingMobile" : ""
              }`}
            >
              <div className="row">
                {showReportIcons && (llShowOnly || haveValue(guarantor_id)) && (
                  <div
                    className="col-1 hideOnMobile cursor-pointer"
                    onClick={handleGoBack}
                  >
                    <div className="userfixed_css userback_css d-flex align-items-center justify-content-center">
                      <div>
                        <p className="Profileheading_change1">
                          <img
                            src={UserBack}
                            alt="Vector Icon"
                            className="vactorImg"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`col-1 hideOnMobile ${
                    showReportIcons && (llShowOnly || haveValue(guarantor_id))
                      ? "ps-0"
                      : ""
                  }`}
                >
                  <div className="userfixed_css d-flex align-items-center justify-content-center">
                    <div>
                      <p className="Profileheading_change">
                        {haveValue(forensicAnalysis?.Name?.dataInJSON?.name)
                          ? getInitials(forensicAnalysis.Name.dataInJSON.name)
                          : getInitials(
                              `${user?.fname ?? ""} ${user?.lname ?? ""}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                {!llShowOnly && (
                  <div
                    className={`col documentNumberWrapper kycNumberWrapper ${
                      llShowOnly ? "guarantorCountWrapper" : ""
                    }`}
                  >
                    <div className="d-flex gap-2">
                      <img
                        src={ProfileImg}
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                      <div className="documentNumberContainer">
                        <p className="Profileheading_change mb-2">
                          {kycDetails?.type === "dni"
                            ? _t(
                                "dniNieDetails",
                                "On new Skor Lite tenantDetails page header"
                              )
                            : _t("passport")}
                        </p>
                        <div className="d-flex align-items-center custom-gap-2 numberWrapper">
                          <p className="Profileheading_change2">
                            {kycDetails?.value}
                            {haveValue(
                              user?.onfido_user_kyc?.onfido_workflow_res
                            ) &&
                              (() => {
                                const status =
                                  user?.onfido_user_kyc?.onfido_workflow_res
                                    ?.resource?.status ||
                                  user?.onfido_user_kyc?.onfido_workflow_res
                                    ?.status;

                                const isDeclined = status === "declined";
                                const isReview = status === "review";

                                if (
                                  !haveValue(status) ||
                                  (!isDeclined && !isReview)
                                )
                                  return null;

                                const icon = isDeclined
                                  ? crossIcon
                                  : MissingIcon;
                                const extraClass = isReview
                                  ? "exclamationIcon"
                                  : "";

                                return (
                                  <div className="exclamationIconWrapper">
                                    <img
                                      src={icon}
                                      className={`missingIcon ${extraClass}`}
                                    />
                                    <div className="guarantor-hover exclamationHover">
                                      <div className="content-hover-div">
                                        <div className="d-flex align-items-center custom-gap-2">
                                          <p className="text-break contentText">
                                            {getReviewReason()}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })()}
                          </p>
                          {!llShowOnly &&
                            haveValue(
                              user?.tenant_extra_field_id?.forensic_analysis
                                ?.profileReports
                            ) && (
                              <div
                                style={{ display: "inline-block" }}
                                data-tooltip-id={
                                  isProfileOutdated
                                    ? "redo-kyc-blocked-tooltip"
                                    : undefined
                                }
                              >
                                <div
                                  className={`editButton ${isProfileOutdated ? "disabled pe-none" : "cursor-pointer"}`}
                                  style={
                                    isProfileOutdated
                                      ? { opacity: 0.5 }
                                      : undefined
                                  }
                                  onClick={() => {
                                    if (!isProfileOutdated)
                                      setShowKycPopup(true);
                                  }}
                                >
                                  <img src={"/images/redoIcon.svg"} />
                                  <p>{_t("redo")}</p>
                                </div>
                                <ReactTooltip
                                  id="redo-kyc-blocked-tooltip"
                                  place="top"
                                  className="react-tooltip-styling"
                                  render={() =>
                                    isProfileOutdated ? (
                                      <p>
                                        {_t(
                                          "profileOutdatedRenewFirst",
                                          "Your profile is outdated. Please renew your profile first."
                                        )}
                                      </p>
                                    ) : null
                                  }
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col documentNumberWrapper hideOnMobile">
                  <div className="d-flex gap-2">
                    <img src={bagImg} alt="Vector Icon" className="vactorImg" />
                    <div>
                      <p className="Profileheading_change mb-2">
                        {_t("employmentStatus")}
                      </p>
                      <p className="Profileheading_change2">
                        {getEmploymentStatus()}
                      </p>
                    </div>
                  </div>
                </div>
                {llShowOnly &&
                  haveValue(user?.onfido_user_kyc?.onfido_workflow_res) && (
                    <div
                      style={{ minWidth: "fit-content" }}
                      className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper"
                    >
                      <div className="d-flex gap-2">
                        <img
                          src={ProfileImg}
                          alt="Vector Icon"
                          className="vactorImg"
                        />
                        <div
                          className="cursor-pointer"
                          onClick={(e) => setShowAmlKycChecks(true)}
                        >
                          <p className="Profileheading_change mb-2">
                            {_t("kycAndAmlChecks")}
                          </p>
                          <div className="d-flex align-items-center gap-1">
                            <img
                              src={
                                amlKycChecks(user, kycResolution)
                                  ? "/images/trusted.svg"
                                  : notIcon
                              }
                              alt=""
                              className="notIconHeader"
                            />
                            <p className="Profileheading_change2">
                              {_t(
                                amlKycChecks(user, kycResolution)
                                  ? "approvedKycAml"
                                  : "notApprovedKycAMl"
                              )}
                              {/* #NOTE: if default is false but AML is approved, show ! */}
                              {!isKycAmlDefaultApproved(user)
                                ? amlKycChecks(user, kycResolution)
                                  ? " !"
                                  : null
                                : null}
                            </p>
                            {showReportIcons && (
                              <img
                                className="Imagerutate ImageSizeSet ms-1"
                                src={VectorIcon}
                                alt="Vector Icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {llShowOnly && (
                  <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper">
                    <div className="d-flex gap-2">
                      <img
                        src={EmployeImg}
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                      <div
                        className="cursor-pointer"
                        onClick={(e) => setShowDefaulterCheck(true)}
                      >
                        <p className="Profileheading_change mb-2">
                          {_t("experianCheck")}
                        </p>
                        <div className="d-flex align-items-center gap-1">
                          <img
                            src={
                              isDefaulter(experianData)
                                ? notIcon
                                : "/images/trusted.svg"
                            }
                            alt=""
                            className="notIconHeader"
                          />
                          <p className="Profileheading_change2">
                            {_t(isDefaulter(experianData) ? "no" : "yes")}
                          </p>
                          {showReportIcons && (
                            <img
                              className="Imagerutate ImageSizeSet ms-1"
                              src={VectorIcon}
                              alt="Vector Icon"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {llShowOnly && isInsurable && (
                  <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper">
                    {console.log(
                      "showReportIconsshowReportIcons",
                      showReportIcons
                    )}
                    <div
                      className="d-flex gap-2 cursor-pointer"
                      onClick={() =>
                        !showReportIcons ? {} : setInsurableModal(true)
                      }
                    >
                      <img
                        src="/images/shield.svg"
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                      <div className="cursor-pointer">
                        <p className="Profileheading_change mb-2">
                          {_t("insurable")}
                        </p>
                        <div className="d-flex align-items-center gap-1">
                          <img
                            src={
                              isDefaulter(experianData)
                                ? notIcon
                                : "/images/trusted.svg"
                            }
                            alt=""
                            className="notIconHeader"
                          />
                          <p className="Profileheading_change2">
                            {_t(!isDefaulter(experianData) ? "yes" : "no")}
                          </p>
                          {showReportIcons && (
                            <img
                              className="Imagerutate ImageSizeSet ms-1"
                              src={VectorIcon}
                              alt="Vector Icon"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper">
                  <div
                    className="d-flex gap-2 cursor-pointer"
                    onClick={() => {
                      if (isMobile && !llShowOnly) {
                        if (
                          +(
                            user?.gurantor_added_id?.length +
                              flaggedGuarantors ?? 0
                          ) === 0
                        ) {
                          navigate("/guarantor/onboarding");
                        } else {
                          setOpenGuarantorModel(true);
                        }
                      } else if (
                        showReportIcons &&
                        ((user?.gurantor_for?.length ?? 0) > 0 ||
                          (user?.gurantor_id?.length ?? 0) > 0 ||
                          +(
                            user?.gurantor_added_id?.length +
                              flaggedGuarantors ?? 0
                          ) > 0)
                      ) {
                        setOpenGuarantorModel(true);
                      }
                    }}
                  >
                    <img
                      src={Guarantors}
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <div className="wrapper">
                      <p className="Profileheading_change mb-2">
                        {user?.gurantor_for?.length > 0 || isGuarantor
                          ? _t("guarantorFor")
                          : _t("guarantors")}
                      </p>
                      <div className="d-flex align-items-center custom-gap-2">
                        <p className="Profileheading_change2">
                          {user?.gurantor_for?.length > 0 || isGuarantor
                            ? (user?.gurantor_for?.length ?? 0)
                            : (((llShowOnly
                                ? user?.gurantor_added_id?.filter((item) =>
                                    [
                                      "processing",
                                      "present",
                                      "accepted",
                                    ].includes(item.status)
                                  )?.length
                                : user?.gurantor_added_id?.length) ?? 0) +
                                flaggedGuarantors ?? 0)}
                        </p>
                        {showReportIcons &&
                          ((user?.gurantor_for?.length ?? 0) > 0 ||
                            (user?.gurantor_id?.length ?? 0) > 0 ||
                            +(
                              user?.gurantor_added_id?.length +
                                flaggedGuarantors ?? 0
                            ) > 0) && (
                            <img
                              className="Imagerutate ImageSizeSet"
                              src={VectorIcon}
                              alt="Vector Icon"
                            />
                          )}
                        {!isGuarantor &&
                          !llShowOnly &&
                          !((user?.gurantor_for?.length ?? 0) > 0) && (
                            <div
                              className="cursor-pointer editButton"
                              onClick={
                                +(
                                  user?.gurantor_added_id?.length +
                                    flaggedGuarantors ?? 0
                                ) === 0
                                  ? () => navigate("/guarantor/onboarding")
                                  : () => setOpenGuarantorModel(true)
                              }
                            >
                              <img
                                src={
                                  +(
                                    user?.gurantor_added_id?.length +
                                      flaggedGuarantors ?? 0
                                  ) === 0
                                    ? "/images/addGreen.svg"
                                    : "/images/editGreen.svg"
                                }
                              />
                              <p>
                                {+(
                                  user?.gurantor_added_id?.length +
                                    flaggedGuarantors ?? 0
                                ) === 0
                                  ? `${_t("add")}`
                                  : `${_t("edit")}`}
                              </p>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                {!isGuarantor && !(user?.gurantor_for?.length ?? 0) > 0 && (
                  <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper position-relative">
                    {showAppWelcomePopup && (
                      <div className="welcome-popup applications-welcome-popup">
                        <div className="content-hover-div">
                          <img
                            src={Cancelimg}
                            alt=""
                            className="welcome-popup-close"
                            onClick={() => setShowAppWelcomePopup(false)}
                          />
                          <p className="text-break contentText">
                            {_t("applicationSectionPopupMessage")}
                          </p>
                        </div>
                      </div>
                    )}
                    <div
                      className="d-flex gap-2 align-items-start cursor-pointer"
                      onClick={() => {
                        setShowApplicationsModal(true);
                      }}
                    >
                      <img
                        src="/images/multiple_users_icon_unfilled.svg"
                        alt="User Icon"
                        style={{ objectFit: "contain", height: "18px" }}
                      />
                      <div className="wrapper">
                        <div className="d-flex align-items-center custom-gap-2 mb-2">
                          <p className="Profileheading_change">
                            {_t("applications")}
                          </p>
                          {!llShowOnly &&
                            pendingApplications.length > 0 &&
                            !applicationsLoading && (
                              <span className="applications-pending-badge">
                                {pendingApplications.length}
                              </span>
                            )}
                        </div>
                        <div className="d-flex align-items-center custom-gap-2">
                          {llShowOnly ? (
                            landlordTenantAppsLoading ? (
                              <p className="Profileheading_change2 applications-fetching-text">
                                {_t("fetching", "fetching...")}
                              </p>
                            ) : (
                              <p className="Profileheading_change2">
                                {landlordTenantApps.length}
                              </p>
                            )
                          ) : applicationsLoading ? (
                            <p className="Profileheading_change2 applications-fetching-text">
                              {_t("fetching", "fetching...")}
                            </p>
                          ) : (
                            <p className="Profileheading_change2">
                              {myApplications.length}
                            </p>
                          )}
                          {(llShowOnly
                            ? landlordTenantApps.length
                            : myApplications.length) > 0 && (
                            <img
                              className="Imagerutate ImageSizeSet"
                              src={VectorIcon}
                              alt="Vector Icon"
                            />
                          )}
                          {!llShowOnly && (
                            <div
                              className="cursor-pointer editButton"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowApplicationsModal(true);
                              }}
                            >
                              <img
                                src={
                                  myApplications.length === 0
                                    ? "/images/addGreen.svg"
                                    : "/images/editGreen.svg"
                                }
                                alt=""
                              />
                              <p>{_t("add")}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {llShowOnly && isInsurable && (
                  <div
                    style={{ maxWidth: "fit-content", paddingLeft: "0" }}
                    className="col-1 d-flex align-items-end justify-content-end hideOnMobile"
                  >
                    {" "}
                    <IncomeTooltip />
                  </div>
                )}
              </div>
            </div>
          </div>
          <Summary
            user={user}
            showReportIcons={showReportIcons}
            setShowChatBot={setShowChatBot}
            llShowOnly={llShowOnly}
            isShowOnMobile={true}
            isOpen={isOpenSummary}
            setIsOpen={setIsOpenSummary}
          />
          <div
            className={`${
              llShowOnly ? "col-md-2 aboutMeCardWrapper" : "col-md-2"
            }`}
          >
            <div
              className="col incomeDiv aboutMeCard"
              onClick={() => llShowOnly && setIsOpenSummary(true)}
            >
              <div
                className={`d-flex gap-2 ${
                  llShowOnly ? "h-100 mainWrapperButtonHeading" : ""
                }`}
              >
                <div className="w-100 wrapperButtonHeading">
                  <div className="d-flex align-items-center custom-gap-2">
                    <img
                      src={
                        llShowOnly
                          ? "/images/summaryIcon.svg"
                          : "/images/message-dots-solid.svg"
                      }
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <p className="Profileheading_change">
                      {llShowOnly ? _t("profileSummary") : _t("aboutMe")}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-4 custom-mt-1">
                    <div className="d-flex align-items-center w-100">
                      {llShowOnly ? (
                        <div
                          className="viewSummaryButton d-flex align-items-center justify-content-between"
                          role="button"
                        >
                          {_t("viewSummary")}
                          <img src="/images/arrow-right.svg" />
                        </div>
                      ) : (
                        <p className="Profileheading_change3 aboutMeDescription">
                          {user?.about_me
                            ? user.about_me.length > 10
                              ? `${user.about_me.slice(0, 10)}...`
                              : user.about_me
                            : _t("noInformation")}
                        </p>
                      )}
                    </div>
                    {showReportIcons && !llShowOnly && (
                      <div className="infodorpdown summarydropdum position-relative">
                        <div
                          onClick={() => setShowFreeTextPopup(true)}
                          className="cursor-pointer editButton"
                        >
                          <img
                            src={
                              (user?.about_me?.length ?? 0) === 0
                                ? "/images/addGreen.svg"
                                : "/images/editGreen.svg"
                            }
                          />
                          <p>
                            {(user?.about_me?.length ?? 0) === 0
                              ? `${_t("add")}`
                              : `${_t("edit")}`}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showReportIcons && llShowOnly && (
            <>
              <div className="col-md-2 send-feedback-button-wrapper">
                <div className="col-auto gap-4 reportButtonWrapper">
                  {WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                    originalUser?.current_workspace_role
                  ) && (
                    <div
                      className="reportbox  d-flex gap-2 cursor-pointer align-items-center"
                      onClick={() => SetIsSentEmailDrawer(true)}
                    >
                      <img
                        src="/images/send-report-green.svg"
                        alt="Vector Icon"
                      />
                      <p>{_t("sendReport")}</p>
                    </div>
                  )}
                  <div className="d-flex gap-2">
                    <div
                      className="reportbox view-details-comp bgColorChange viewDetailIconContainer gap-2 cursor-pointer d-flex align-items-center"
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_SKOR_LITE_URL}${currentLang}/report/${user?._id}`,
                          "_blank"
                        )
                      }
                    >
                      <img
                        src="/images/view-details-green.svg"
                        alt="Vector Icon"
                      />
                    </div>
                    {WORKSPACE_ROLES_CAPABILITIES?.tenants?.generateReport?.includes(
                      originalUser?.current_workspace_role
                    ) && (
                      <div
                        className="reportbox view-details-comp bgColorChange viewDetailIconContainer gap-2 cursor-pointer d-flex align-items-center"
                        onClick={handleNavigateReport}
                      >
                        <img
                          src="/images/download-report-green.svg"
                          alt="Vector Icon"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {/* #NOTE: hide applications modal for guarantor */}
      {!isGuarantorUser && (
        <ApplicationsModal
          isOpen={showApplicationsModal}
          onClose={() => setShowApplicationsModal(false)}
          applications={
            llShowOnly
              ? landlordTenantApps
              : [
                  ...pendingApplications.map((a) => ({
                    ...a,
                    isPendingInvitation: true,
                  })),
                  ...myApplications,
                ]
          }
          loading={llShowOnly ? landlordTenantAppsLoading : applicationsLoading}
          onNewApplication={() => setShowNewApplicationModal(true)}
          onApplicationsChange={loadApplicationsData}
          llShowOnly={llShowOnly}
        />
      )}
      <NewApplicationModal
        isOpen={showNewApplicationModal}
        onClose={() => {
          setShowNewApplicationModal(false);
          setShowApplicationsModal(true);
        }}
        onSuccess={loadApplicationsData}
      />
      {showKycPopup && (
        <FullidAuthentication
          user={user}
          isGuarantor={isGuarantor}
          usedFor={"popup"}
          setShowKycPopup={setShowKycPopup}
        />
      )}
      {showFreeTextPopup && (
        <FreeTextModal
          user={user}
          showFreeTextPopup={showFreeTextPopup}
          setShowFreeTextPopup={setShowFreeTextPopup}
          updateTenantData={updateTenantData}
          loadFullInfo={loadFullInfo}
          isPopup={true}
        />
      )}

      {showAmlKycChecks && (
        <KycAmlCheckReportModal
          isOpen={showAmlKycChecks}
          onClose={(e) => setShowAmlKycChecks(false)}
          user={user}
          resolutions={kycResolution}
          onResolutionChange={loadKycResolutions}
        />
      )}
    </>
  );
};

export default TenantDetailsHeader;
